export const site = {
  name: "Link Ideas Technologies Pvt Ltd",
  shortName: "LITPL",
  url: "https://www.litpl.com",
  email: "sales@litpl.com",
  phoneDisplay: "+91 99070 36906",
  phoneTel: "+919907036906",
  whatsappNumber: "919907036906",
  linkedin: "https://www.linkedin.com/company/ashishagrawalpr/",
  facebook: "https://www.facebook.com/people/Link-Ideas-Technologies-Pvt-Ltd-LITPL/61560079274566/",
  logo: "https://www.litpl.com/static/img/logo.png",
  shareImage: "/static/img/og-image.jpg",
  // Head office. Clients are served across Africa and India; see `markets`.
  address: {
    addressLocality: "Bhilai",
    addressRegion: "Chhattisgarh",
    postalCode: "490020",
    addressCountry: "IN",
  },
  // Head office coordinates (WGS84), used for structured data, the map embed, and the directions link.
  geo: { latitude: 21.202449031640697, longitude: 81.3298185650436 },
  mapsUrl: "https://www.google.com/maps?q=21.202449031640697,81.3298185650436",
  mapsEmbedUrl: "https://maps.google.com/maps?q=21.202449031640697,81.3298185650436&z=16&output=embed",
  hoursLabel: "Monday–Saturday, 10:00–19:00 IST",
  // Market positioning used in titles, descriptions, and structured data.
  marketsLabel: "Africa · India · Remote delivery worldwide",
  marketsSentence: "Working with businesses across Africa and India, with remote delivery and on-site visits when the project needs them.",
  areaServed: ["Africa", "India"],
  regions: [
    { name: "Africa", note: "Our primary market. Port, ICD, and CFS operators, manufacturers, distributors, mining supply chains, transporters, and commodity traders across the continent, served remotely with on-site visits when the project needs them." },
    { name: "India", note: "Head office in Bhilai, Chhattisgarh. Manufacturing, trading, transport, retail, and agribusiness clients." },
  ],
  // Working window shown in the time zones most clients use. Base window is 10:00–19:00 IST (UTC+5:30).
  hoursByZone: [
    { zone: "IST", label: "India", window: "10:00–19:00" },
    { zone: "EAT", label: "Africa (UTC+3)", window: "07:30–16:30" },
    { zone: "CAT / SAST", label: "Africa (UTC+2)", window: "06:30–15:30" },
    { zone: "WAT", label: "Africa (UTC+1)", window: "05:30–14:30" },
    { zone: "GMT", label: "Africa (UTC+0)", window: "04:30–13:30" },
  ],
  // Verified proof points shown under the homepage hero, e.g. ["12", "countries delivered in"]. Leave empty until the figures are confirmed.
  proofPoints: [] as [string, string][],
  // Partner or client logos shown with the proof points. Add only with permission; files go under /public/static/img/logos.
  logos: [] as { src: string; alt: string }[],
  deliveryModel: [
    ["Remote first", "Discovery, configuration, training, and support run over video calls, screen sharing, and WhatsApp, in your working hours."],
    ["On-site when it matters", "Go-live, yard or plant walkthroughs, and key user training can be delivered on site by arrangement."],
    ["Support you can reach", "WhatsApp is the fastest channel. Email and phone are answered during the working window, and support windows for other time zones are agreed per project."],
  ] as [string, string][],
};

export const postalAddress = {
  "@type": "PostalAddress" as const,
  ...site.address,
};

export const geoCoordinates = {
  "@type": "GeoCoordinates" as const,
  latitude: site.geo.latitude,
  longitude: site.geo.longitude,
};

/** Head-office Place for schema.org `location` fields. */
export const headOfficePlace = {
  "@type": "Place" as const,
  name: `${site.shortName} head office`,
  address: postalAddress,
  geo: geoCoordinates,
  hasMap: site.mapsUrl,
};

export function whatsappHref(text: string) {
  return `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(text)}`;
}

export function trackContact(method: "call" | "whatsapp" | "email" | "form") {
  if (typeof window === "undefined") return;
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
  gtag?.("event", "generate_lead", { method });
}
